<div (drop)="dropFiles($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (click)="fileInput.click()"
  (keydown.enter)="fileInput.click()" (keydown.space)="fileInput.click()" class="file-dropzone" tabindex="0"
  role="button">
  <input type="file" #fileInput multiple (change)="selectFiles($event)">
  <div class="file-dropzone-content">
    <mat-icon class="lg">cloud_upload</mat-icon>
    <p>Drop files or click here to upload</p>
  </div>
</div>
